import {
  Grid, Paper, Select, Table, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, withStyles, MenuItem, FormControl, InputLabel
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import SampleStatusModel from "../../GenomicsResearch-Panel/pages/sampleStatus";
import moment, { min } from "moment";
import LinearProgress from '@material-ui/core/LinearProgress';
import { MessageRounded } from "@material-ui/icons";
import { generateGenomicsResearchFilterUrl } from "../../helpers/generateUrl";
import {
  getCities, getClient, getDealer, getInstitute, getProjects, getSampleAccessioning
} from "../actions/GenomicsResearchAction";
import TicketCommentsModal from "./comments";
import "./filter.sass";
import { style } from "@mui/system";
import { Tooltip } from "@mui/material";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    card: {
      height: "100%",
      padding: theme.spacing(1),
    },
    card_grid: {
      justifyContent: "space-between",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem",
      width: "100%",
    },
    tableWidth: {
      maxWidth: "40%"
    }

  })
);

interface Props {
  getCities: any;
  cities: any;
  getSampleAccessioning: any;
  getDealer: any;
  dealer: any;
  getClient: any;
  client: any;
  getInstitute: any;
  institute: any;
  getProjects: any;
  projects: any;
  loading: Boolean;
}

const GenomicsBrowseData: React.FC<Props> = ({
  getCities,
  cities,
  getSampleAccessioning,
  getDealer,
  dealer,
  getClient,
  client,
  getInstitute,
  institute,
  getProjects,
  projects,
  loading,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [dealers, setDealers] = useState<any>();
  const [dealersName, setDealersName] = useState<any>("");
  const [clientName, setClientgName] = useState<any>("");
  const [clients, setClients] = React.useState<any>();
  const [insName, setInsName] = useState<any>("");
  const [instituteName, setInstituteName] = useState<any>();
  const [project, setProject] = useState<any>("");
  const [sampleRecevied, setSamplerecived] = React.useState<any>("");
  const [page, setPage] = useState(0);
  const timer = useRef<any>(0);
  const [openModal, setopenModal] = useState<boolean>(false);
  const [openModal1, setopenModal1] = useState<boolean>(false);
  const [projectSamplesData, setProjectSampleData] = useState<any>("")
  const [projectStatus, setProjectStatus] = useState<any>("")
  const [runData, setRunData] = useState<any>("")
  const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
      head: {
        backgroundColor: "#12145e",
        color: theme.palette.common.white,
        fontSize: "14px",
      },
      body: {
        fontSize: 14,
      },
    })
  )(TableCell);
  const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
      root: {
        "&:nth-of-type(odd)": {
          backgroundColor: theme.palette.action.hover,
        },
      },
    })
  )(TableRow);
  const filterBrowseData = (e: any) => {
    const body: any = {
      scientist: clients,
      institute: instituteName,
      dealer: dealers,
      projectId: project,
      createdAt: sampleRecevied,
      phase: projectStatus,
    };
    const url = generateGenomicsResearchFilterUrl(body).substring(2);
    getProjects(url);
    setPage(0);
  };
  useEffect(() => {
    getProjects(`?limit=100`);
  }, []);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = projects.links && projects.links.next.split("?")[1];
      getProjects(`?${url}`);
    } else if (newPage < page) {
      let url = projects.links && projects.links.previous.split("?")[1];
      getProjects(`?${url}`);
    }
    setPage(newPage);
  };
  const handleClick = (data: any) => {
    setopenModal(true);
    setProjectSampleData(data?._id);
  };
  const handleExport = () => {
    exportToCsv('ProjectStatusData.csv', [
      ['S No', 'Month', 'Project Id', 'Client Name', 'Institute', 'Firm Name', 'Application', 'PO Date', 'Sample Receving Date',
        'Sample Receving month', 'No of samples', 'No. of samples processed', 'Library QC Status', 'Library QC Date',
        'Library QC month', 'Sequencing Status', 'Sequencing Date', 'sequencing month', 'Analysis', 'Analysis Date ',
        'PO Link', 'Qc Report', 'Sif File', 'Project Value', 'PO No.', 'Invoice Status', 'Invoice Value', 'Invoice date', 'Payment Status', 'Amount Recived', 'Project Status'],
      ...projects?.results?.map((p: any, index: number) => [
        index + 1, months[moment(p?.createdAt).month()], p?.projectId, p?.scientist?.name, p?.institute?.name, p?.dealer?.firmName, p?.subProjects?.length > 0 && p?.subProjects?.map((val: any) =>
          val?.application?.name
        ),
        p?.sample?.poDate ? new Date(p?.sample?.poDate).toLocaleString() : "", p?.sample?.createdAt ? new Date(p?.sample?.createdAt).toLocaleString() : "NA", p?.sample?.createdAt ? months[moment(p?.sample?.createdAt).month()] : "NA",
        p?.sample?.poCount, p?.libraryQCPassCount, p?.libraryCreatedCount === 0 ? "Pending" : p?.librariesCount === p?.libraryCreatedCount ? "Completed" : "Completed", p?.libraryQcDate ? new Date(p?.libraryQcDate).toLocaleString() : "NA",
        p?.libraryQcDate ? months[moment(p?.libraryQcDate).month()] : "NA", p?.dataFulfilled === true ? "Completed" : "Pending",
        p?.dataFulfilledDate ? new Date(p?.dataFulfilledDate).toLocaleString() : "NA", p?.dataFulfilledDate ? months[moment(p?.dataFulfilledDate).month()] : "N/A",
        p?.bioInformatics?.analysisStatus, p?.bioInformatics?.analysisCompletionDate ? new Date(p?.bioInformatics?.analysisCompletionDate).toLocaleString() : "NA",
        p?.sample?.trfPo, p?.sample?.accessions && p?.sample?.accessions?.map((val: any) => val?.qcReport), p?.sample?.accessions && p?.sample?.accessions?.map((val: any) => val?.sifFile),
        p?.invoiceAmount, p?.sample?.poNumber, p?.invoiceStatus, p?.invoiceAmount?.receivedAmount, p?.invoiceDate ? new Date(p?.invoiceDate).toLocaleString() : "NA", p?.paymentStatus, p?.receivedAmount, p?.phase,
      ])
    ])
  };

  function exportToCsv(filename: any, rows: any) {
    var processRow = function (row: any) {
      var finalVal = '';
      for (var j = 0; j < row.length; j++) {
        var innerValue = !row[j] || row[j] === null ? '' : row[j]?.toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        };
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0)
          result = '"' + result + '"';
        if (j > 0)
          finalVal += ',';
        finalVal += result;
      }
      return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }
    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const handleCommentClick = (data: any) => {
    setopenModal1(true);
    setRunData(data);
  };

  return (
    <>
      <main className={classes.content}>
        <form onSubmit={filterBrowseData}>
          <div className={classes.toolbar} />
          <Grid
            container
            spacing={2}
            direction="row"
            style={{ alignItems: "right" }}
          >
            <Grid item xs={12} sm={8}>
              <h4 style={{ fontWeight: "bold" }}>GENOMICS BROWSE DATA</h4>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1}
            direction="row"
            alignItems="center"
            justify="flex-start"
          >
            <Grid item xs={12} sm={4} md={2}>
              <Autocomplete
                id="Project"
                onChange={(event, newValue) => {
                  if (newValue) {
                    setProject(newValue?.projectId);
                  } else {
                    setProject("")
                  }
                }}
                options={projects?.results || []}
                blurOnSelect
                getOptionLabel={(option: any) => {
                  return (
                    (option?.projectId) +
                    " " +
                    (option?.institute?.name || "") +
                    " " +
                    (option?.scientist?.name || "") +
                    "," +
                    (option?.dealer?.firmName || "")
                  );
                }}
                onInputChange={(event, newInputValue) => {
                  let data = newInputValue.split(" ");
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    if (data.length > 0) {
                      getProjects(`?projectId=${data[0]}`);
                    }
                  }, 1000);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="input"
                    label="Project"
                    placeholder="Search ID/Client/Dealer Name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Autocomplete
                disablePortal
                id="client_name"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                    setClients(obj._id);
                  }
                }}
                defaultValue={
                  { _id: "", name: clientName }
                }
                options={client?.results || []}
                blurOnSelect
                disableClearable={clientName === ""}
                disableCloseOnSelect
                getOptionLabel={(option: any) => `${option?.name}`}
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getClient(`name=${newInputValue}`);
                  }, 1000);
                  setClientgName(newInputValue);
                }}
                renderInput={(params) =>
                  <TextField
                    {...params}
                    className="input"
                    label="Client"
                    variant="outlined"
                    placeholder="Search Client Name"
                    fullWidth
                  />}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Autocomplete
                disablePortal
                id="Institute"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                    setInstituteName(obj._id);
                  }
                }}
                defaultValue={
                  { id: "", name: insName }
                }
                options={institute.results || []}
                blurOnSelect
                disableClearable={insName === ""}
                disableCloseOnSelect
                getOptionLabel={(option: any) => `${option?.name}`}
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getInstitute(`name=${newInputValue}`);
                  }, 1000);
                  setInsName(newInputValue);
                }}
                renderInput={(params) =>
                  <TextField
                    {...params}
                    className="input"
                    label="Institute Name"
                    placeholder="Search Institute Name"
                    variant="outlined"
                    fullWidth
                  />}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Autocomplete
                disablePortal
                id="Dealer"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                    setDealers(obj._id);
                  }
                }}
                defaultValue={
                  { id: "", firmName: dealersName }
                }
                options={dealer.results || []}
                blurOnSelect
                disableClearable={dealers === "" || dealersName === ""}
                disableCloseOnSelect
                getOptionLabel={(option: any) => `${option?.firmName}`}
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getDealer(`name=${newInputValue}`);
                  }, 1000);
                  setDealersName(newInputValue);
                }}
                renderInput={(params) =>
                  <TextField
                    {...params}
                    className="input"
                    label="Dealer Name"
                    placeholder="Search Dealer name"
                    variant="outlined"
                    fullWidth
                  />}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <TextField
                name="expiry_date"
                type="date"
                value={sampleRecevied}
                className="input"
                label="Sample Recived Date"
                variant="outlined"
                onChange={(e) => setSamplerecived(e.target.value as string)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <FormControl style={{ width: "100%" }} className="input">
                <InputLabel>Project Status</InputLabel>
                <Select
                  label="Project Status"
                  variant="outlined"
                  className="input"
                  fullWidth
                  required
                  value={projectStatus || "none"}
                  style={{ width: "100%", height: "40px" }}
                  onChange={(e) => setProjectStatus(e.target.value)}
                >
                  <MenuItem value="none" disabled><em>Select Project Status</em></MenuItem>
                  <MenuItem value="Created">Project Created</MenuItem>
                  <MenuItem value="Data Fulfilled">Data Fulfilled</MenuItem>
                  <MenuItem value="Bio Informatics">Bio Informatics</MenuItem>
                  <MenuItem value="Closed">Closed</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Button
                variant="contained"
                style={{ backgroundColor: "#9c27b0", color: "white" }}
                fullWidth
                onClick={filterBrowseData}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Button
                variant="contained"
                style={{ backgroundColor: "#1565c0", color: "white" }}
                fullWidth
                onClick={() => history.go("/dashboard/gnre/browseData")}
              >
                Reset
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Button
                style={{ backgroundColor: "#14a37f", color: "white" }}
                variant="contained"
                fullWidth
                onClick={handleExport}
              >
                Export
              </Button>
            </Grid>
            <Grid item xs={12} sm={12}>
              Tat Information:<br />
              <div style={{ alignItems: "left", display: "inline-block", margin: "1rem" }}>
                <div className="r-cl" style={{ display: "flex" }}><div className="boxStyle" style={{ border: "1px solid", width: "15px", height: "15px", background: "#a10320" }}></div><div style={{ marginLeft: "5px" }}>Delay</div></div>
                <div className="r-cl" style={{ display: "flex" }}><div className="boxStyle" style={{ border: "1px solid", width: "15px", height: "15px", background: "#069c18" }}></div><div style={{ marginLeft: "5px" }}>Completed On Time</div></div>
                <div className="r-cl" style={{ display: "flex" }}><div className="boxStyle" style={{ border: "1px solid", width: "15px", height: "15px", background: "#007bff" }}></div><div style={{ marginLeft: "5px" }}>Pending</div></div>
                <div className="r-cl" style={{ display: "flex" }}><div className="boxStyle" style={{ border: "1px solid", width: "15px", height: "15px", background: "#FFD600" }}></div><div style={{ marginLeft: "5px" }}>Partial Pass/All Fail(eg: 1st case-10 samples recived, but in qc 1 sample failed/ 2nd case- 10 samples recived and all samples are failed)</div></div>
              </div>
            </Grid>
          </Grid>
          <br />
          <TableContainer className={classes.tableContainer} component={Paper} style={{ maxHeight: "550px", marginTop: "1px" }}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="center">S No.</StyledTableCell>
                  <StyledTableCell align="center">Month</StyledTableCell>
                  <StyledTableCell align="center">Project ID</StyledTableCell>
                  <StyledTableCell align="center">TaT</StyledTableCell>
                  <StyledTableCell align="center">Client Name</StyledTableCell>
                  <StyledTableCell align="center">Institute Name</StyledTableCell>
                  <StyledTableCell align="center">Dealer</StyledTableCell>
                  <StyledTableCell align="center">Project Title</StyledTableCell>
                  <StyledTableCell align="center">No Of Subprojects</StyledTableCell>
                  <StyledTableCell align="center">Data Requirements(GB)</StyledTableCell>
                  <StyledTableCell align="center">Project Comment History</StyledTableCell>
                  <StyledTableCell align="center">Application</StyledTableCell>
                  <StyledTableCell align="center">PlatForm</StyledTableCell>
                  <StyledTableCell align="center">BD Point</StyledTableCell>
                  <StyledTableCell align="center">Quotaion File</StyledTableCell>
                  <StyledTableCell align="center">P/O File</StyledTableCell>
                  <StyledTableCell align="center">SIF File</StyledTableCell>
                  <StyledTableCell align="center">Condition Report</StyledTableCell>
                  <StyledTableCell align="center">P/O Samples</StyledTableCell>
                  <StyledTableCell align="center">Received Samples</StyledTableCell>
                  <StyledTableCell align="center">Pass Samples</StyledTableCell>
                  <StyledTableCell align="center">Fail Samples</StyledTableCell>
                  <StyledTableCell align="center">Sample Type</StyledTableCell>
                  <StyledTableCell align="center">Accessiong Addition File</StyledTableCell>
                  <StyledTableCell align="center">Sample Qc Report</StyledTableCell>
                  <StyledTableCell align="center">Sample Status</StyledTableCell>
                  <StyledTableCell align="center">Sample Qc Status</StyledTableCell>
                  <StyledTableCell align="center">Library</StyledTableCell>
                  <StyledTableCell align="center">Library QC Report</StyledTableCell>
                  <StyledTableCell align="center">Library Status</StyledTableCell>
                  <StyledTableCell align="center">Sequencing Status</StyledTableCell>
                  <StyledTableCell align="center">Final Data Qc File</StyledTableCell>
                  <StyledTableCell align="center">Data Qc Date</StyledTableCell>
                  <StyledTableCell align="center">Data Qc Sent to Client</StyledTableCell>
                  <StyledTableCell align="center">Pre Analysis Call</StyledTableCell>
                  <StyledTableCell align="center">Analysis Status</StyledTableCell>
                  <StyledTableCell align="center">Final Report</StyledTableCell>
                  <StyledTableCell align="center">Supplementary File</StyledTableCell>
                  <StyledTableCell align="center">Deliverable Add File</StyledTableCell>
                  <StyledTableCell align="center">Payment Status</StyledTableCell>
                  <StyledTableCell align="center">Project Amount</StyledTableCell>
                  <StyledTableCell align="center">Received Amount</StyledTableCell>
                  <StyledTableCell align="center">Invoice Status</StyledTableCell>
                  <StyledTableCell align="center">Project Status</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {projects && projects?.results && projects?.results?.length > 0 && projects?.results?.map((data: any, index: any) => {
                  let firstDate: any = new Date(data.createdAt).getTime();
                  let currentDate: any = new Date().getTime();
                  let differenceOfDate = currentDate - firstDate;
                  let differenceInDays = differenceOfDate / (1000 * 60 * 60 * 24);
                  return (
                    <StyledTableRow >
                      <StyledTableCell align="center">
                        {projects?.page_size *
                          (page + 1 - 1) +

                          (index + 1)}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.createdAt ? months[moment(data?.createdAt).month()] : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data.projectId}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.phase === "Closed" ? "" : differenceInDays ? Math?.round(differenceInDays) : ""} day <br />
                        {data?.data?.billingCompleted === undefined}
                        {(data?.sampleQCCount !== data?.sampleQCFailCount||(data?.sampleQCFailCount+data?.sampleQCCount)===0) ?
                          <div>{data?.createdAt && data?.billingCompleted === undefined ? <LinearProgress variant="buffer" color={differenceInDays > 60 ? "secondary" : "primary"} value={Math?.round(differenceInDays)} valueBuffer={Math?.round(differenceInDays - 60)} style={{ minWidth: "400px", height: "10px", background: "" }} /> : <p style={{ backgroundColor: "#F57F17" }}>Project Closed</p>} </div>
                          : <div style={{ backgroundColor: "#d6b41a" }}>Hold Project</div>}

                        <div className="progress" style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: '2px', width: "500px" }}>
                          {/* lib count=sample qc pass count and within 15 days phase complete then sample qc completed */}
                          {data?.dataFulfilled === true ?
                            <div className="progress-bar progress-bar-success" style={{ background: data?.dataFulfilled === true ? "#069c18" : "" }}>
                              <p style={{ marginTop: 16 }}>Sample Qc</p>
                            </div>
                            : <div className="progress-bar progress-bar-success" style={{ background: data?.sampleQcReport ? (data?.sampleQCFailCount ? "#FFD600" : "#069c18") : (differenceInDays > 15 ? "#a10320" : "#007bff") }}>
                              <p style={{ marginTop: 16 }}>Sample Qc</p>
                            </div>}

                          {data?.dataFulfilled === true ?
                            <div className="progress-bar progress-bar-success" style={{ background: data?.dataFulfilled === true ? "#069c18" : "" }}>
                              <p style={{ marginTop: 16 }}>Libraray Qc</p>
                            </div>
                            :
                            <div className="progress-bar progress-bar-success" style={{ background: data?.libraryQcReport ? (data?.libraryQCFailCount ? "#FFD600" : "#069c18") : (differenceInDays > 30 ? "#a10320" : "#007bff") }}>
                              Libaray Qc
                            </div>
                          }
                          {differenceInDays <= 45 && data?.dataFulfilled === false ?
                            <div className="progress-bar progress-bar-success">
                              <p style={{ marginTop: 16 }}>Sequencing</p>
                            </div>
                            :
                            <div className="progress-bar progress-bar-success" style={{ background: data?.dataFulfilled === true ? "#069c18" : (differenceInDays > 45 ? "#a10320" : "#007bff") }}>
                              Sequencing
                            </div>
                          }
                          {differenceInDays <= 60 && data?.bioInformatics?.createdAt === "" || data?.bioInformatics === undefined ?
                            <div className="progress-bar progress-bar-success">
                              <p style={{ marginTop: 16 }}>BioInformatics</p>
                            </div>
                            :
                            <div className="progress-bar progress-bar-danger" style={{ background: data?.bioInformatics?.createdAt ? "#069c18" : (differenceInDays > 60 ? "#a10320" : "#007bff") }}>
                              <p style={{ marginTop: 16 }}>BioInformatics</p>
                            </div>
                          }
                          {differenceInDays <= 70 && data?.billingCompleted === undefined ?
                            <div className="progress-bar progress-bar-success">
                              <p style={{ marginTop: 16 }}>Billing</p>
                            </div>
                            :
                            <div className="progress-bar progress-bar-danger" style={{ background: data?.billingCompleted === true ? "#069c18" : "" }}>
                              Billing
                            </div>
                          }
                        </div>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.scientist?.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.institute?.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.dealer?.firmName}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.subProjects?.length > 0 && data?.subProjects?.map((val: any) => val?.title).join(",")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.subProjects?.length}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.subProjects?.length > 0 && data?.subProjects[0].dataSizeRequirement ? data?.subProjects?.map((val: any) => val?.dataSizeRequirement).join(",") : data?.dataSizeRequirement}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.comment !== "" ?
                          <div>
                            <MessageRounded
                              onClick={() => handleCommentClick(data)}
                            />
                          </div>
                          : ""}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.subProjects?.length > 0 && data?.subProjects?.map((val: any) => val?.application?.name).join(", ")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.subProjects?.length > 0 && data?.subProjects?.map((val: any) => val?.platform).join(", ")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.bdPoint}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.quotation ?
                          <a href={data?.sample?.quotation} target="_blank" rel="noreferrer">View</a>
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.trfPo ?
                          <a href={data?.sample?.trfPo} target="_blank" rel="noreferrer">View</a>
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.sifFile ? <><a href={data?.sample?.sifFile} target="_blank" rel="noopener noreferrer">View</a><br /></> : ""}
                        {data?.sample?.accessions && data?.sample?.accessions?.map((val: any) => {
                          return (
                            val?.sifFile ? <><a href={val?.sifFile} target="_blank" rel="noopener noreferrer">View</a><br /></> : ""
                          )
                        })}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.qcReport ? <><a href={data?.sample?.qcReport} target="_blank" rel="noopener noreferrer">View</a><br /></> : ""}
                        {data?.sample?.accessions && data?.sample?.accessions?.map((val: any) => val?.qcReport ? <><a href={val?.qcReport} target="_blank" rel="noopener noreferrer">View</a><br /></> : "")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.poCount}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.receivedCount}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.passedCount}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.failedCount}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.type}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sample?.additional ?
                          <a href={data?.sample?.additional} target="_blank" rel="noreferrer">View</a>
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sampleQcreport ?
                          <a href={data?.sampleQcreport} target="_blank" rel="noreferrer">View</a>
                          : ""}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <div>
                          <DataThresholdingIcon
                            onClick={() => handleClick(data)}
                          />
                        </div>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.sampleQCPassCount === 0 ? "Pending" : data?.sampleQCCount === data?.sampleQCPassCount ? "Completed" : "Partial Completed"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.librariesCount}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.libraryQcReport ?
                          <a href={data?.libraryQcReport} target="_blank" rel="noreferrer">View</a>
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.libraryCreatedCount === 0 ? "Pending" : data?.librariesCount === data?.libraryCreatedCount ? "Completed" : "Partial Completed"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.dataFulfilled === true ? "Completed" : "Pending"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.bioInformatics?.finalDataQcFile ?
                          <a href={data?.bioInformatics?.finalDataQcFile} target="_blank" rel="noreferrer">View</a>
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.finalDataQcDate ? new Date(data?.finalDataQcDate).toLocaleString() : "NA"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.bioInformatics?.finalDataQcSentToClient === true ? "Yes" : "No"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.bioInformatics?.preAnalysisCall === true ? "Yes" : "NO"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.bioInformatics?.analysisStatus ? data?.bioInformatics?.analysisStatus : "NA"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.deliverable?.finalAnalysisReport ?
                          <a href={data?.deliverable?.finalAnalysisReport} target="_blank" rel="noreferrer">View</a>
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.deliverable?.supplementaryFile ?
                          <a href={data?.deliverable?.supplementaryFile} target="_blank" rel="noreferrer">View</a>
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.deliverable?.additionalFile ?
                          <a href={data?.deliverable?.additionalFile} target="_blank" rel="noreferrer">View</a>
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.paymentStatus ? data?.paymentStatus : "NA"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.invoiceAmount ? data?.invoiceAmount : "NA"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.receivedAmount ? data?.receivedAmount : "NA"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.invoiceStatus ? data?.invoiceStatus : "NA"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.phase}
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                })}
              </TableBody>
              <TableFooter>
                <TablePagination
                  rowsPerPageOptions={[]}
                  colSpan={3}
                  count={projects?.count || 0}
                  rowsPerPage={projects?.page_size}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </TableFooter>
            </Table>
          </TableContainer>
        </form>
        <SampleStatusModel
          openModal={openModal}
          setopenModal={setopenModal}
          projectSamplesData={projectSamplesData}
        />
        <TicketCommentsModal
          openModal1={openModal1}
          setopenModal1={setopenModal1}
          rundata={runData}
        />
      </main >
    </>
  );
};

const mapStateToProps = (state: any) => ({
  cities: state.GenomicsCAReducer.cities,
  samplesAccessioning: state.GenomicsCAReducer.samplesAccessioning,
  dealer: state.GenomicsCAReducer.dealer,
  client: state.GenomicsCAReducer.client,
  institute: state.GenomicsCAReducer.institute,
  projects: state.GenomicsCAReducer.projects,
});

export default connect(mapStateToProps, {
  getCities,
  getSampleAccessioning,
  getDealer,
  getClient,
  getInstitute,
  getProjects,
})(GenomicsBrowseData);